export const NAME = 'userRole';
export const USER_ROLE_FORM = 'userRole';
export const PROJECT_ROLES_TABLE = 'projectRolesTable';
export const LIST_NAME = 'userRoleList';
